import React, { Component } from "react";
//import styled from "@emotion/styled";
import Iframe from "react-iframe";
// import SpecialEvent from "./SpecialEvent";
// import gbThumb from "../../assets/images/GB_thumb.png";
//import Calendar2022 from "../../assets/images/ChristmasCalendar_2022.png";

// const EventsList = styled.ul`
// 	margin: 0;
// 	padding-left: 0;
// 	list-style: none;
// 	background-color: #fff;
// `;

class Events extends Component {
	constructor(props) {
		super(props);
		var bgClass = props.background === "dark" ? "special-row" : "";
		this.state = { backgroundClass: bgClass };
	}
	render() {
		return (
			<section id="events" className={`padding100 ${this.state.backgroundClass}`}>
				<div className="container">
					<h1 className="text-center">
						<strong>Upcoming Events</strong>
					</h1>
					<div className="divider">
						<i className="fa fa-star"></i>
					</div>

					<p className="lead">
						<Iframe
							url="https://crckingston.elvanto.com.au/calendar_embed/?c[]=410d5777-00f3-4956-859f-ce9f39da51ac&c[]=02f4ea0a-80d0-473f-aaed-5ae7ad70e5f8&events=1&upcoming[count]=1&upcoming[timeframe]=m&max=4"
							width="100%"
							height="265px"
							position="relative"
						/>
					</p>
					<br />
					<p className="text-right" style={{ fontSize: "16px" }}>
						A full calendar of our regularly scheduled events can be found <a href="/Events">HERE</a>
					</p>
					<br />

					{/* <h3 className="text-center">
						<strong>Special Events</strong>
					</h3>
					<div>
						<a href="/events"><img className="img img-responsive" src={Calendar2022} alt="" /></a>
					</div> */}
					{/* <EventsList>
						<SpecialEvent
							href="/events/gingerbread"
							image={gbThumb}
							title="Gingerbread House Making"
							date="Thursday 24 & Friday 25 November, 2022"
						/>
					</EventsList> */}
				</div>
			</section>
		);
	}
}

export default Events;
